import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDownloadCertificateMutation } from '../../features/courses/coursesAPI';

const CertificatePreview = () => {
    const { id } = useParams(); 
    const [downloadCertificate] = useDownloadCertificateMutation();
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCertificate = async () => {
            try {
                const blob = await downloadCertificate(id).unwrap();
                const file = new Blob([blob], { type: 'application/pdf' });
                const url = URL.createObjectURL(file);
                setPdfUrl(url);
            } catch (error) {
                console.error('Failed to load certificate preview:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCertificate();
    }, [id, downloadCertificate]);

    return (
        <div className="max-w-5xl mx-auto py-8 px-4">
            <h1 className="text-2xl font-bold mb-4">Certificate Preview</h1>

            {loading ? (
                <p>Loading...</p>
            ) : pdfUrl ? (
                <>
                    <iframe
                        src={pdfUrl}
                        width="100%"
                        height="700px"
                        title="Certificate Preview"
                        className="rounded-xl border shadow"
                    ></iframe>
                    <div className="mt-4">
                        <a
                            href={pdfUrl}
                            download={`certificate_${id}.pdf`}
                            className="inline-block bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                        >
                            Download Certificate
                        </a>
                    </div>
                </>
            ) : (
                <p>Certificate could not be displayed.</p>
            )}
        </div>
    );
};

export default CertificatePreview;
